module.exports = __webpack_public_path__ + "static/logo-1327473b9801113bffc343159d637041.png";